/* 合并表格 */
export function formatRowspanAndColspan(tableData, tableKey) {
    const newArr = []
    // 分类检出的数据push到newArr中
    for (let i = 0; i < tableData.length;) {
      let count = 0
      for (let j = i; j < tableData.length; j++) {
        if (tableKey === 'order_no') {
          if (tableData[i].order_no === tableData[j].order_no) {
            count++
          }
        }
      }
      if (tableKey === 'order_no') {
        newArr.push({
          data: tableData[i].order_no,
          num: count
        })
      }
      i += count
    }
    // 根据此算法，格式化newArr中的数据
    for (let k = 0; k < newArr.length; k++) {
      if (newArr[k].num > 1 || newArr[k].num === 0) {
        for (let w = k; w < newArr[k].num + k - 1; w++) {
          newArr.splice(w + 1, 0, {
            data: newArr[k].data,
            num: 0
          })
        }
      }
    }
    return newArr
  }